import { render, staticRenderFns } from "./swiperEdit.vue?vue&type=template&id=a66759ca&"
import script from "./swiperEdit.vue?vue&type=script&lang=js&"
export * from "./swiperEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports